import { render, staticRenderFns } from "./MatchOptionsManualMatchResults.vue?vue&type=template&id=4fe41ff0&scoped=true&"
import script from "./MatchOptionsManualMatchResults.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsManualMatchResults.vue?vue&type=script&lang=js&"
import style0 from "./MatchOptionsManualMatchResults.vue?vue&type=style&index=0&id=4fe41ff0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe41ff0",
  null
  
)

export default component.exports